import React, { useMemo } from "react";
import WeeklyPlannerPage from "./WeeklyPlannerPage";
import ObjectiveLibraryPage from "./ObjectiveLibraryPage";
import LessonLibraryPage from "./LessonLibraryPage";
import StrategiesLibraryPage from "./StrategiesLibraryPage";
import ObservationHistoryPage from "./ObservationHistoryPage";
import "./PlanningHubPage.css";

const TABS = [
  { key: "week", label: "Week" },
  { key: "objectives", label: "Custom Objectives" },
  { key: "lessons", label: "Lessons" },
  { key: "strategies", label: "Strategies" },
  { key: "observations", label: "Observations" },
];

const normalizeTab = (value) => {
  const safe = String(value || "").trim().toLowerCase();
  if (TABS.some((tab) => tab.key === safe)) return safe;
  return "week";
};

const PlanningHubPage = ({
  courseId,
  currentCourse,
  authProfile,
  activeTab,
  onNavigateTab,
  onOpenLesson,
}) => {
  const tab = useMemo(() => normalizeTab(activeTab), [activeTab]);

  return (
    <section className="planning-hub-page">
      <div className="planning-hub-tabs" role="tablist" aria-label="Planning Hub views">
        {TABS.map((item) => (
          <button
            key={item.key}
            type="button"
            role="tab"
            aria-selected={tab === item.key}
            className={`planning-hub-tab ${tab === item.key ? "active" : ""}`}
            onClick={() => onNavigateTab?.(item.key)}
          >
            {item.label}
          </button>
        ))}
      </div>

      <div className="planning-hub-content">
        {tab === "week" && <WeeklyPlannerPage courseId={courseId} />}
        {tab === "objectives" && <ObjectiveLibraryPage currentCourse={currentCourse} />}
        {tab === "lessons" && (
          <LessonLibraryPage
            courseId={courseId}
            onOpenLesson={onOpenLesson}
          />
        )}
        {tab === "strategies" && <StrategiesLibraryPage courseId={courseId} />}
        {tab === "observations" && <ObservationHistoryPage authProfile={authProfile} />}
      </div>
    </section>
  );
};

export default PlanningHubPage;
